module.exports = __webpack_public_path__ + "img/single_value_chart.7c44042e.svg";